

import new1 from "../img/news/Dina_Sangu.optimized.webp"
import new2 from "../img/news/Kalai_thamilagam.optimized.webp"
import new3 from "../img/news/Seithi_Alasal.optimized.webp"
import new4 from "../img/news/Udaga_malar.optimized.webp"
import new6 from "../img/news/Urimai_kural.optimized.webp"
import tor1 from  "../img/record/18hrs1.optimized.webp"
import tor2 from  "../img/record/18hrs2.optimized.webp"
import tor3 from  "../img/record/18hrs3.optimized.webp"
import tor4 from  "../img/record/kbor1.optimized.webp"
import tor5 from  "../img/record/kbor2.optimized.webp"
import tor6 from  "../img/record/kbor3.optimized.webp"


export const galleryData = {
  tournaments: [
    { id: 1, src: tor1 },
    { id: 2, src: tor2 },
    { id: 3, src: tor3 },
    { id: 4, src: tor4 },
    { id: 5, src: tor5 },
    { id: 6, src: tor6 },

  ],
  papercuts: [
    { id: 3, src: new1 },
    { id: 4, src: new2 },
    { id: 5, src: new3 },
    { id: 6, src: new4 },
    { id: 8, src: new6 },
  ],
 
};
